import { render } from "./AddShortCutSetting.vue?vue&type=template&id=57334f96&scoped=true"
import script from "./AddShortCutSetting.vue?vue&type=script&lang=js"
export * from "./AddShortCutSetting.vue?vue&type=script&lang=js"

import "./AddShortCutSetting.vue?vue&type=style&index=0&id=57334f96&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57334f96"]])

export default __exports__